export default __webpack_public_path__ + "static/media/Lumen.a97f5db9.PNG";